/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiserviceMelcoFusionModelsFusionAppSetting,
    ApiserviceMelcoFusionModelsFusionAppSettingFromJSON,
    ApiserviceMelcoFusionModelsFusionAppSettingToJSON,
    ApiserviceMelcoModelsDefaultAppSetting,
    ApiserviceMelcoModelsDefaultAppSettingFromJSON,
    ApiserviceMelcoModelsDefaultAppSettingToJSON,
    ApiserviceMelcoModelsError,
    ApiserviceMelcoModelsErrorFromJSON,
    ApiserviceMelcoModelsErrorToJSON,
} from '../models';

export interface ApiServiceSettingsApiAccountProductSettingsEditApiServiceAppSettingRequest {
    apiserviceMelcoFusionModelsFusionAppSetting?: ApiserviceMelcoFusionModelsFusionAppSetting;
}

/**
 * 
 */
export class ApiServiceSettingsApi extends runtime.BaseAPI {

    /**
     */
    async accountProductSettingsDeleteApiServiceAppSettingRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api_service/settings/app`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async accountProductSettingsDeleteApiServiceAppSetting(): Promise<void> {
        await this.accountProductSettingsDeleteApiServiceAppSettingRaw();
    }

    /**
     */
    async accountProductSettingsEditApiServiceAppSettingRaw(requestParameters: ApiServiceSettingsApiAccountProductSettingsEditApiServiceAppSettingRequest): Promise<runtime.ApiResponse<ApiserviceMelcoFusionModelsFusionAppSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/api_service/settings/app`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiserviceMelcoFusionModelsFusionAppSettingToJSON(requestParameters.apiserviceMelcoFusionModelsFusionAppSetting),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiserviceMelcoFusionModelsFusionAppSettingFromJSON(jsonValue));
    }

    /**
     */
    async accountProductSettingsEditApiServiceAppSetting(requestParameters: ApiServiceSettingsApiAccountProductSettingsEditApiServiceAppSettingRequest): Promise<ApiserviceMelcoFusionModelsFusionAppSetting> {
        const response = await this.accountProductSettingsEditApiServiceAppSettingRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async accountProductSettingsGetApiServiceAppSettingRaw(): Promise<runtime.ApiResponse<ApiserviceMelcoFusionModelsFusionAppSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api_service/settings/app`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiserviceMelcoFusionModelsFusionAppSettingFromJSON(jsonValue));
    }

    /**
     */
    async accountProductSettingsGetApiServiceAppSetting(): Promise<ApiserviceMelcoFusionModelsFusionAppSetting> {
        const response = await this.accountProductSettingsGetApiServiceAppSettingRaw();
        return await response.value();
    }

    /**
     */
    async settingsGetApiServiceDefaultAppSettingRaw(): Promise<runtime.ApiResponse<ApiserviceMelcoModelsDefaultAppSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api_service/defaults/settings/app`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiserviceMelcoModelsDefaultAppSettingFromJSON(jsonValue));
    }

    /**
     */
    async settingsGetApiServiceDefaultAppSetting(): Promise<ApiserviceMelcoModelsDefaultAppSetting> {
        const response = await this.settingsGetApiServiceDefaultAppSettingRaw();
        return await response.value();
    }

}
